import styled, { css } from 'styled-components';

import Colours from '/shared/styled/Colours';

interface ItemProps {
  $isHighlighted?: boolean;
}

function highlightedStyled({ $isHighlighted = false }: ItemProps) {
  if ($isHighlighted) {
    return css`
      background: ${Colours.green};
      color: ${Colours.white};
    `;
  }
}

export const StyledInfoListItem = styled.li<ItemProps>`
  background: ${Colours.white};
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 0.9rem;
  line-height: 1.3;
  font-weight: 400;

    > div:first-child{
        min-height: 8rem;
        font-size: 1.1rem;
        padding-bottom: 0.5rem;
        border-bottom: 1px solid ${Colours.greyLight6};
        margin-bottom: 1rem;
        font-weight: 300;
    }

  > :last-child {
    font-size: 2rem;
    font-weight: bold;
    padding: 2rem 0;
    text-align: center;

    > :nth-child(2) {
      font-size: 1.2rem;
      font-weight: 300;
    }
  }
  ${highlightedStyled}
`;

export default styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 1rem;
`;
